// extracted by mini-css-extract-plugin
export default {"container":"success-screen_container__5ocpd","title":"success-screen_title__RlSvk","description":"success-screen_description__gUr8W"};